export const stream_data = {
  "streams": [
    {
      "name": "Science",
      "degrees": [
        {
          "name": "B.Sc",
          "specializations": ["Physics", "Chemistry", "Mathematics", "Biology", "Computer Science", "Biotechnology", "Environmental Science", "Microbiology", "Zoology", "Botany", "Information Technology"]
        },
        {
          "name": "B.Tech",
          "specializations": ["Computer Science", "Mechanical", "Civil", "Electrical", "Electronics & Communication", "Chemical", "Aerospace", "Biomedical", "IT", "Automation & Robotics"]
        },
        {
          "name": "MBBS",
          "specializations": ["General Medicine", "Surgery", "Pediatrics", "Dermatology", "Orthopedics", "Radiology"]
        },
        {
          "name": "BDS",
          "specializations": ["Oral Surgery", "Orthodontics", "Prosthodontics", "Periodontics"]
        },
        {
          "name": "BPT",
          "specializations": ["Musculoskeletal", "Neurological", "Cardiopulmonary", "Pediatric"]
        },
        {
          "name": "B.Sc Nursing",
          "specializations": ["General Nursing", "Midwifery", "Community Health"]
        },
        {
          "name": "B.Pharm",
          "specializations": ["Pharmaceutics", "Pharmacology", "Pharmaceutical Chemistry", "Quality Assurance"]
        },
        {
          "name": "B.Sc Biotechnology",
          "specializations": ["Molecular Biology", "Genetics", "Biochemistry", "Bioinformatics"]
        },
        {
          "name": "B.Sc Environmental Science",
          "specializations": ["Ecology", "Conservation", "Environmental Chemistry", "Climate Studies"]
        },
        {
          "name": "BAMS",
          "specializations": ["Ayurveda Medicine & Surgery"]
        },
        {
          "name": "BHMS",
          "specializations": ["Homeopathy Medicine & Surgery"]
        },
        {
          "name": "BUMS",
          "specializations": ["Unani Medicine & Surgery"]
        }
      ]
    },
    {
      "name": "Commerce",
      "degrees": [
        {
          "name": "B.Com",
          "specializations": ["Accounting", "Finance", "Taxation", "Banking", "Insurance"]
        },
        {
          "name": "BBA",
          "specializations": ["Management", "Marketing", "Finance", "HR", "International Business"]
        },
        {
          "name": "BMS",
          "specializations": ["Business Management", "Finance", "Marketing"]
        },
        {
          "name": "CA",
          "specializations": ["Chartered Accountancy"]
        },
        {
          "name": "CS",
          "specializations": ["Company Secretary"]
        },
        {
          "name": "CMA",
          "specializations": ["Cost Management Accounting"]
        },
        {
          "name": "BBI",
          "specializations": ["Banking", "Insurance", "Finance"]
        },
        {
          "name": "BFM",
          "specializations": ["Financial Markets", "Investments", "Portfolio Management"]
        },
        {
          "name": "BAF",
          "specializations": ["Accounting", "Finance", "Taxation", "Auditing"]
        }
      ]
    },
    {
      "name": "Arts",
      "degrees": [
        {
          "name": "BA",
          "specializations": ["History", "Political Science", "Sociology", "Psychology", "Philosophy", "Economics", "Geography", "Languages"]
        },
        {
          "name": "BFA",
          "specializations": ["Painting", "Sculpture", "Applied Arts", "Photography", "Interior Design"]
        },
        {
          "name": "BA LLB",
          "specializations": ["Constitutional Law", "Criminal Law", "Corporate Law"]
        },
        {
          "name": "B.Ed",
          "specializations": ["Primary Education", "Secondary Education", "Special Education"]
        },
        {
          "name": "Journalism / BJMC",
          "specializations": ["Print Media", "Broadcast Media", "Digital Media"]
        },
        {
          "name": "Mass Communication",
          "specializations": ["Advertising", "PR", "Media Studies", "Film Studies"]
        },
        {
          "name": "BA Economics",
          "specializations": ["Microeconomics", "Macroeconomics", "Statistics", "Finance"]
        },
        {
          "name": "BA Fashion / Design",
          "specializations": ["Fashion Design", "Textile Design", "Accessory Design"]
        },
        {
          "name": "BA Social Work (BSW)",
          "specializations": ["Community Development", "Counseling", "NGO Management"]
        }
      ]
    },
    {
      "name": "Vocational",
      "degrees": [
        {
          "name": "Hotel Management",
          "specializations": ["Front Office", "Food & Beverage", "Housekeeping", "Event Management"]
        },
        {
          "name": "Fashion Design",
          "specializations": ["Apparel Design", "Textile Design", "Accessory Design", "Footwear Design"]
        },
        {
          "name": "Animation",
          "specializations": ["2D Animation", "3D Animation", "VFX", "Game Design"]
        },
        {
          "name": "Event Management",
          "specializations": ["Corporate Events", "Wedding Planning", "Exhibition Management", "Sports Event Management"]
        },
        {
          "name": "Travel & Tourism",
          "specializations": ["Tour Operations", "Travel Consultancy", "Hospitality Management"]
        },
        {
          "name": "Culinary Arts",
          "specializations": ["Baking", "International Cuisine", "Food Safety"]
        }
      ]
    },
    {
      "name": "ITI",
      "degrees": [
        {
          "name": "Electrician",
          "specializations": ["Domestic Wiring", "Industrial Wiring"]
        },
        {
          "name": "Plumber",
          "specializations": ["Sanitary Work", "Pipe Fitting"]
        },
        {
          "name": "Welder",
          "specializations": ["Arc Welding", "Gas Welding", "TIG/MIG Welding"]
        },
        {
          "name": "Fitter",
          "specializations": ["Mechanical Fitting", "Precision Fitting"]
        },
        {
          "name": "Mechanic",
          "specializations": ["Automobile", "Diesel", "Motorcycle", "Industrial Machinery"]
        },
        {
          "name": "Carpenter",
          "specializations": ["Woodwork", "Furniture Making"]
        },
        {
          "name": "Turner",
          "specializations": ["Metal Turning", "Lathe Operations"]
        }
      ]
    },
    {
      "name": "Agriculture",
      "degrees": [
        {
          "name": "B.Sc Agriculture",
          "specializations": ["Horticulture", "Soil Science", "Agronomy", "Plant Pathology"]
        },
        {
          "name": "B.Tech Agriculture Engineering",
          "specializations": ["Farm Machinery", "Irrigation Engineering", "Soil & Water Engineering"]
        }
      ]
    },
    {
      "name": "Paramedical",
      "degrees": [
        {
          "name": "B.Sc Radiology",
          "specializations": ["Diagnostic Imaging", "Therapeutic Radiology"]
        },
        {
          "name": "B.Sc OT (Operation Theatre Technology)",
          "specializations": ["Surgical Procedures", "Patient Care"]
        },
        {
          "name": "B.Sc Medical Lab Technology",
          "specializations": ["Hematology", "Microbiology", "Clinical Biochemistry"]
        }
      ]
    },
    {
      "name": "Management",
      "degrees": [
        {
          "name": "MBA",
          "specializations": [
            "General Management",
            "Business Strategy",
            "Operations Management",
            "Human Resource Management",
            "Marketing Management",
            "Financial Management"
          ]
        },
        {
          "name": "B.Sc OT (Operation Theatre Technology)",
          "specializations": [
            "Surgical Procedures",
            "Patient Care"
          ]
        },
        {
          "name": "B.Sc Medical Lab Technology",
          "specializations": [
            "Hematology",
            "Microbiology",
            "Clinical Biochemistry"
          ]
        }
      ]
    }
  ],
  "years": [2025, 2026, 2027],
  "studying_years": ["1st Year", "2nd Year", "3rd Year", "4th Year"]
}